module.exports = __webpack_public_path__ + "static/media/plug_off.5ea00236.png";